import { PageHero, SectionHeader } from "@/components/Section";
import useReveal from "@/hooks/useReveal";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import StockPhotoNotice from "@/components/StockPhotoNotice";

const ministries = [
  { title: "Men",            verse: "1 Corinthians 16:13", body: "Men of Valor — brotherhood, prayer, and biblical manhood in a broken world.",                image: "https://images.pexels.com/photos/13172188/pexels-photo-13172188.jpeg?auto=compress&cs=tinysrgb&w=1200" },
  { title: "Marriage",       verse: "Ephesians 5:25",      body: "Cultivating covenant marriages rooted in Christ and honoring one another.",                   image: "https://images.pexels.com/photos/9577192/pexels-photo-9577192.jpeg?auto=compress&cs=tinysrgb&w=1200" },
  { title: "Senior Adults",  verse: "Psalm 92:14",         body: "Honoring the wisdom and legacy of the saints who paved the way.",                             image: "https://images.pexels.com/photos/7220111/pexels-photo-7220111.jpeg?auto=compress&cs=tinysrgb&w=1200" },
  { title: "Music Ministry", verse: "Psalm 96:1",          body: "Choir, praise team, and musicians lifting Christ through Spirit-filled worship.",             image: "https://images.pexels.com/photos/7520361/pexels-photo-7520361.jpeg?auto=compress&cs=tinysrgb&w=1200" },
  { title: "Bible Study",    verse: "2 Timothy 2:15",      body: "Mid-week teaching that grounds believers in the whole counsel of God.",                       image: "https://images.pexels.com/photos/6284493/pexels-photo-6284493.jpeg?auto=compress&cs=tinysrgb&w=1200" },
  { title: "Sunday School",  verse: "Deuteronomy 6:7",     body: "Age-graded biblical teaching for every generation, every Sunday at 10 AM.",                   image: "https://images.pexels.com/photos/9577184/pexels-photo-9577184.jpeg?auto=compress&cs=tinysrgb&w=1200" },
  { title: "Prayer Ministry",verse: "James 5:16",          body: "Interceding for our church, our city, and the requests of God's people.",                     image: "https://images.pexels.com/photos/5876583/pexels-photo-5876583.jpeg?auto=compress&cs=tinysrgb&w=1200" },
];

export default function Ministries() {
  useReveal();
  return (
    <div data-testid="ministries-page">
      <PageHero
        eyebrow="Ministries"
        title="A place to grow. A place to serve."
        subtitle="There is a ministry for every season of life at New Philadelphia. Explore how God might be inviting you to grow and to serve."
        image="https://images.pexels.com/photos/7520347/pexels-photo-7520347.jpeg?auto=compress&cs=tinysrgb&w=2000"
      />

      <section className="bg-white py-24">
        <div className="container-npbc">
          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {ministries.map((m, i) => (
              <article
                key={m.title}
                data-reveal
                data-testid={`ministry-item-${m.title.toLowerCase().replace(/\s+/g, "-")}`}
                style={{ transitionDelay: `${(i % 6) * 50}ms` }}
                className="group rounded-2xl overflow-hidden bg-white border border-black/[0.06] shadow-[0_1px_2px_rgba(0,0,0,0.04),0_20px_60px_-30px_rgba(0,0,0,0.15)] hover:-translate-y-1 hover:shadow-[0_1px_3px_rgba(0,0,0,0.05),0_36px_80px_-30px_rgba(0,0,0,0.35)] transition-all duration-500"
              >
                <div className="relative h-56 overflow-hidden">
                  <img src={m.image} alt={m.title} className="h-full w-full object-cover transition-transform duration-[1400ms] group-hover:scale-110" loading="lazy" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                  <div className="absolute bottom-4 left-4 rounded-full bg-npbc-gold/95 text-npbc-black text-[10px] font-bold uppercase tracking-[0.22em] px-3 py-1">
                    {m.verse}
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="heading-serif text-2xl">{m.title}</h3>
                  <p className="mt-2 text-npbc-gray/85 leading-relaxed text-sm">{m.body}</p>
                  <Link to="/contact" className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-npbc-red group-hover:gap-3 transition-all">
                    Learn More <ArrowRight className="h-4 w-4" />
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
      <StockPhotoNotice />
    </div>
  );
}
